import React from 'react';
import './Modal.css';

const Modal = ({ isOpen = false, onClose, title, children, size = 'medium' }) => {
  // Explicitly check isOpen and ensure it's a boolean
  if (!isOpen || isOpen === false) {
    return null;
  }

  // Ensure onClose is a function
  if (!onClose || typeof onClose !== 'function') {
    console.error('Modal: onClose must be a function');
    return null;
  }

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget && onClose) {
      onClose();
    }
  };

  return (
    <div className="modal-backdrop" onClick={handleBackdropClick}>
      <div className={`modal-container modal-${size}`}>
        <div className="modal-header">
          <h3 className="modal-title">{title || ''}</h3>
          <button className="modal-close" onClick={onClose} aria-label="Close modal">
            ×
          </button>
        </div>
        <div className="modal-body">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;